import { Heading } from "@ariakit/react";
import { useState, type Dispatch, type SetStateAction } from "react";
import { lacquer } from "../../common/common.css.ts";
import { diagram, graphic } from "./ThrowdownSimulator.css.ts";

type OnSelected = Dispatch<SetStateAction<Throw>>;

function Shove(props: {
  x: string;
  y: string;
  onSelected: OnSelected;
  currentValue: Throw;
}) {
  const isSelected = props.currentValue === "SHOVE";

  return (
    <g
      transform={`translate(${props.x} ${props.y})`}
      onClick={() => !isSelected && void props.onSelected("SHOVE")}
      className={graphic({ isSelected })}
    >
      <rect x="-2" y="-2" width="52" height="76" fill="transparent" />

      <path d="M18.1957 26.1431L7.35767 29.8186C6.54604 30.0939 6 30.8557 6 31.7127V37.9216C6 38.1732 6.04746 38.4225 6.13988 38.6564L9.56338 47.3226C9.84024 48.0235 10.4875 48.5092 11.2378 48.5792L15.2698 48.9552C15.5854 48.9847 15.9035 48.9387 16.1978 48.821L18.8786 47.7495C19.4391 47.5255 20.0707 47.5666 20.5975 47.8614L22.1772 48.7453C22.4757 48.9123 22.8119 49 23.1539 49H29.6744C30.2968 49 30.8837 48.7102 31.2622 48.2161L44.2885 31.2081C44.728 30.6342 44.8237 29.8679 44.5387 29.2036L44.3726 28.8163C44.0573 28.0812 43.3344 27.6047 42.5345 27.6047H40.0526C39.5463 27.6047 39.0588 27.7967 38.6885 28.142L29.3992 36.8054C29.1129 37.0724 28.7125 37.1792 28.3313 37.0904C27.5234 36.902 27.16 35.9583 27.6329 35.2768L31.0446 30.3594C31.9079 29.1152 31.1288 27.4002 29.6238 27.2317L19.0605 26.0496C18.7688 26.0169 18.4736 26.0489 18.1957 26.1431Z" />
      <path d="M9.07331 26.6351L7.96704 27.0946C6.82575 27.5686 5.53199 26.9044 5.25197 25.7007L3.38892 17.6926C3.16519 16.7309 3.67675 15.7498 4.59336 15.3827L4.94443 15.2421C6.00827 14.8161 7.21183 15.3693 7.58122 16.4541L10.1995 24.1434C10.5392 25.141 10.0465 26.231 9.07331 26.6351Z" />
      <path d="M15.903 24.7996L14.3249 25.242C13.0909 25.5879 11.8545 24.7003 11.7877 23.4205L10.9023 6.45986C10.8468 5.3966 11.634 4.47624 12.6931 4.36629L13.7875 4.25266C14.9028 4.13687 15.8953 4.9604 15.9873 6.07788L17.3564 22.7097C17.435 23.6645 16.8255 24.541 15.903 24.7996Z" />
      <path d="M22.8394 24.3542H21.2711C20.1255 24.3542 19.2141 23.3939 19.2738 22.2499L20.1797 4.89574C20.2352 3.83313 21.113 3 22.177 3H23.7453C24.8909 3 25.8023 3.96029 25.7426 5.10427L24.8367 22.4584C24.7812 23.521 23.9034 24.3542 22.8394 24.3542Z" />
      <path d="M29.5224 25.3237L28.3417 24.9559C27.2784 24.6247 26.6905 23.4888 27.034 22.4294L31.4304 8.87255C31.7452 7.90184 32.7403 7.3238 33.7395 7.53128L34.835 7.75877C35.994 7.99943 36.6915 9.18841 36.3361 10.3175L32.0249 24.0146C31.694 25.066 30.5748 25.6515 29.5224 25.3237Z" />

      <text x="24" y="70" textAnchor="middle" className={lacquer}>
        Shove
      </text>
    </g>
  );
}

function Thump(props: {
  x: string;
  y: string;
  onSelected: OnSelected;
  currentValue: Throw;
}) {
  const isSelected = props.currentValue === "THUMP";

  return (
    <g
      transform={`translate(${props.x} ${props.y})`}
      onClick={() => !isSelected && void props.onSelected("THUMP")}
      className={graphic({ isSelected })}
    >
      <rect x="-2" y="-2" width="52" height="76" fill="transparent" />

      <path d="M4.19058 29.1606L6.49482 26.5683C6.82024 26.2022 7 25.7294 7 25.2396V21.4249C7 20.8381 7.25765 20.281 7.7047 19.901L15.6547 13.1435C16.4233 12.4902 17.558 12.5115 18.3015 13.193L27.5481 21.6691C28.3535 22.4074 28.4174 23.6555 27.6915 24.4721L26.1768 26.1761C25.5051 26.9318 24.3749 27.0673 23.5436 26.4917L19.4517 23.6589C18.887 23.2679 18.1325 23.294 17.5961 23.7231C16.7937 24.3651 16.824 25.5951 17.657 26.1968L23.2491 30.2355C24.1936 30.9176 24.3575 32.2594 23.6049 33.1487L20.1897 37.185C19.7773 37.6723 19.7209 38.3681 20.0493 38.9155C20.5383 39.7305 21.6547 39.8862 22.348 39.2362L27.7101 34.2093C28.4467 33.5187 29.5826 33.4855 30.3583 34.1319L33.0275 36.3563C34.0285 37.1904 33.9773 38.7438 32.9235 39.5102L24.526 45.6175C24.1841 45.8661 23.7723 46 23.3496 46H17.8886C17.3229 46 16.7836 45.7604 16.4044 45.3406L4.2012 31.8299C3.51755 31.073 3.51297 29.9229 4.19058 29.1606Z" />
      <path d="M25.349 6.56952L22.1874 10.8808C21.5324 11.774 21.7281 13.0295 22.6239 13.681L25.0652 15.4565C25.8839 16.0519 27.0184 15.9418 27.7072 15.2L31.4294 11.1914C32.2581 10.299 32.1035 8.87936 31.1022 8.18615L28.1002 6.10786C27.2095 5.49119 25.9897 5.69588 25.349 6.56952Z" />
      <path d="M37.889 15.2279L35.9643 13.1107C35.1764 12.244 33.8158 12.2369 33.0188 13.0951L29.3114 17.0877C28.5794 17.876 28.6021 19.1021 29.3628 19.8628L30.375 20.875C31.0335 21.5335 32.0594 21.6504 32.8492 21.1568L37.4692 18.2693C38.5269 17.6082 38.7281 16.1509 37.889 15.2279Z" />
      <path d="M30.7048 26.2399L38.5247 20.46C39.544 19.7066 40.9982 20.0794 41.5294 21.2303L42.6297 23.6145C43.105 24.6441 42.6299 25.8625 41.5831 26.2987L32.8615 29.9327C32.052 30.27 31.1172 30.0406 30.5558 29.3669L30.3572 29.1286C29.6208 28.2449 29.7798 26.9236 30.7048 26.2399Z" />
      <path d="M41.5559 28.9721L35.9819 31.759C34.7609 32.3695 34.4968 33.9968 35.4621 34.9621L35.626 35.126C36.1616 35.6616 36.954 35.8487 37.6726 35.6091L43.4877 33.6708C44.5794 33.3069 45.1396 32.099 44.7122 31.0306L44.3073 30.0181C43.8727 28.9317 42.6024 28.4488 41.5559 28.9721Z" />

      <text x="20" y="70" textAnchor="middle" className={lacquer}>
        Thump
      </text>
    </g>
  );
}

function Pinch(props: {
  x: string;
  y: string;
  onSelected: OnSelected;
  currentValue: Throw;
}) {
  const isSelected = props.currentValue === "PINCH";

  return (
    <g
      transform={`translate(${props.x} ${props.y})`}
      onClick={() => !isSelected && void props.onSelected("PINCH")}
      className={graphic({ isSelected })}
    >
      <rect x="-2" y="-2" width="52" height="76" fill="transparent" />

      <path d="M10.5034 15.1986L9.13638 19.7728L6.11864 30.5531C6.03632 30.8472 5.88776 31.1185 5.68434 31.3463L2.33777 35.0932C1.59983 35.9194 1.67406 37.1881 2.50331 37.9226L9.3104 43.9521C10.0039 44.5664 11.0286 44.624 11.7866 44.0913L14.8425 41.9434C15.1287 41.7423 15.4625 41.6197 15.8108 41.5879L21.1723 41.0986C21.3382 41.0835 21.5015 41.0477 21.6585 40.9921L30.582 37.8304C30.8027 37.7522 31.0079 37.6359 31.1884 37.4867L38.9754 31.049C39.7835 30.381 39.9385 29.2023 39.3307 28.3481L38.5046 27.1871C37.9808 26.4509 37.0283 26.1573 36.1809 26.4709L29.5762 28.9152C29.354 28.9974 29.119 29.0395 28.8821 29.0395H23.5505C22.397 29.0395 21.4827 28.0665 21.5543 26.9152L21.7013 24.5547L21.9178 21.0769C21.9573 20.4435 22.295 19.8665 22.8278 19.5218L26.8614 16.9131C27.2728 16.647 27.7675 16.5412 28.2517 16.6157L33.4849 17.4208C33.8226 17.4728 34.1415 17.6105 34.4109 17.8207L39.0067 21.406C39.8064 22.0299 40.9465 21.9564 41.6594 21.235L42.5575 20.3262C43.3019 19.573 43.3302 18.3702 42.622 17.5829L38.8178 13.3534C38.6088 13.1211 38.3484 12.941 38.0572 12.8275L28.1794 8.97699C27.7406 8.80594 27.2555 8.79523 26.8096 8.94674L16.3961 12.4849L11.8429 13.8562C11.1991 14.0501 10.6959 14.5544 10.5034 15.1986Z" />

      <text x="20" y="70" textAnchor="middle" className={lacquer}>
        Pinch
      </text>
    </g>
  );
}

type Throw = "SHOVE" | "THUMP" | "PINCH";
type ThrowResult = `${Throw}:${Throw}`;

function ThrowResultMessage(props: { result: ThrowResult }) {
  switch (props.result) {
    case "PINCH:PINCH": {
      return (
        <>
          We both get to <em>pinch</em> 1 cap from each other simultaneously.
        </>
      );
    }

    case "PINCH:THUMP": {
      return (
        <>
          Your <em>pinch</em> gets cancelled by my <em>thump</em>. I get to roll
          my <em>thump dice</em> against your model, whilst you don&apos;t get
          to <em>pinch</em> any of my caps.
        </>
      );
    }

    case "PINCH:SHOVE": {
      return (
        <>
          Your <em>pinch</em> beats my <em>shove</em>. You get to pinch 1 cap
          from me, whilst your model doesn&apos;t get shoved.
        </>
      );
    }

    case "THUMP:THUMP": {
      return (
        <>
          We both <em>thump</em> each other&apos;s models simultaneously.
        </>
      );
    }

    case "THUMP:SHOVE": {
      return (
        <>
          Your <em>Thump</em> is cancelled by my <em>shove</em>. You must move
          your shoved model, and you don&apos;t get to throw any of your{" "}
          <em>thump dice</em>.
        </>
      );
    }

    case "THUMP:PINCH": {
      return (
        <>
          Your <em>thump</em> beats my <em>pinch</em>. You get to roll your{" "}
          <em>thump dice</em> against my model, whilst I don&apos;t get to{" "}
          <em>pinch</em> any of your caps.
        </>
      );
    }

    case "SHOVE:SHOVE": {
      return (
        <>
          We both <em>shove</em> each other&apos;s models simultaneously,
          pushing them 3” directly away from their starting location.
        </>
      );
    }

    case "SHOVE:PINCH": {
      return (
        <>
          Your <em>shove</em> is cancelled by my <em>pinch</em>. I get to pinch
          1 cap from you, whilst my model doesn&apos;t get shoved.
        </>
      );
    }

    case "SHOVE:THUMP": {
      return (
        <>
          Your <em>shove</em> beats my <em>thump</em>. I must move my shoved
          model, and I don&apos;t get to throw any of my <em>thump dice</em>.
        </>
      );
    }

    default: {
      return props.result;
    }
  }
}

export function ThrowdownSimulator() {
  const [yours, setYours] = useState<Throw>("THUMP");
  const [mine, setMine] = useState<Throw>("PINCH");
  const throwResult: ThrowResult = `${yours}:${mine}`;

  return (
    <div id="throwdown-simulator" className={diagram.container}>
      <Heading className={diagram.heading}>Throwdown Simulator</Heading>

      <p className={diagram.hint}>Choose any combination of throws.</p>

      <svg
        width="360"
        height="220"
        viewBox="0 0 360 220"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          marginInline: "auto",
          marginBlock: "2rem 2.5rem",
          inlineSize: "100%",
          maxInlineSize: "22rem",
          blockSize: "auto",
        }}
      >
        <g transform="translate(-35 0)">
          <text className={diagram.vs}>VS</text>

          <path
            d="M216.802 5C216.802 6.43219 216.802 18.1725 216.859 35.3027C216.883 42.3522 217.15 47.1656 217.092 53.5822C216.798 67.6498 216.887 87.3895 217.104 89.2754C217.232 90.2225 217.397 91.1493 217.8 93.055"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M220.387 130.598C220.193 141.108 220.079 160.473 220.307 166.136C220.802 178.451 220.496 198.107 220.306 205.706C220.235 207.511 220.094 208.624 220.021 210.129C219.948 211.634 219.948 213.499 219.734 215.42"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>

        <text className={diagram.yourThrow}>Your throw</text>
        <Thump x="90" y="50" onSelected={setYours} currentValue={yours} />
        <Shove x="10" y="100" onSelected={setYours} currentValue={yours} />
        <Pinch x="110" y="140" onSelected={setYours} currentValue={yours} />

        <text className={diagram.myThrow}>My throw</text>
        <Thump x="215" y="40" onSelected={setMine} currentValue={mine} />
        <Shove x="305" y="90" onSelected={setMine} currentValue={mine} />
        <Pinch x="225" y="130" onSelected={setMine} currentValue={mine} />
      </svg>

      <div key={throwResult} className={diagram.result}>
        <ThrowResultMessage result={throwResult} />
      </div>
    </div>
  );
}
